<template>
    <div class="retr-list">
        <accordion
            v-for="el in retrList"
            :key="el.name"
            class="retr mt-3"
            :is-active="openedRetrs.includes(el.name)"
            :show-chevron="isNotEmpty(el.retr)"
            @header-click="onHeaderClick(el)"
        >
            <template #header>
                <div class="retr__header">
                    <div class="retr__header-name">
                        <a-icon class="text-orange" icon="Coins" />
                        {{ TYPES_DICT[el.name] }}
                    </div>
                    <div class="retr__header-value">
                        <template v-if="isNotEmpty(el.retr)">
                            {{ el.retr.bonusSum | currency }}
                        </template>
                        <template v-else>
                            -
                        </template>
                    </div>
                </div>
            </template>

            <template #expand-button>
                <div v-if="isNotEmpty(el.retr)" class="d-flex align-items-center">
                    <span class="retr__expand-text text-sm font-weight-normal">
                        Szczegóły
                    </span>

                    <a-icon
                        class="a-accordion__chevron ml-0"
                        icon="Chevron"
                    />
                </div>
            </template>

            <template #body>
                <component :class="el.name" :is="el.component" :retr="el.retr" />
            </template>
        </accordion>
    </div>
</template>

<script>
import { TYPES, TYPES_DICT } from './retr-types'
import { mapTurnoverBonus, mapPaymentTermBonus, mapClaimsAdjustments } from './retr-helper'

export default {
    props: {
        retr: {
            type: Object,
            required: true
        }
    },

    data() {
        return {
            // array of names
            openedRetrs: []
        }
    },

    computed: {
        retrList() {
            return Object.entries(this.retr).map(([name, retrObj]) => {
                let component = 'TableBasic'
                let retr = retrObj || {}
                switch (name) {
                case TYPES.TURNOVER:
                    retr = {
                        ...mapTurnoverBonus(retr),
                        bonusSum: retr.adjustment + retr.invoice
                    }
                    break

                case TYPES.PAYMENT_TERM:
                    retr = {
                        ...mapPaymentTermBonus(retr),
                        bonusSum: retr.standardPaymentBonus + retr.to3DaysPaymentBonus
                    }
                    break

                case TYPES.NETWORK_RETRO:
                case TYPES.NETWORK_RETRO_VIP:
                    component = 'TableNetworkRetroBonus'
                    retr = {
                        ...retr,
                        reclamationButton: true
                    }
                    break
                case TYPES.NETWORK_RETRO_REDUCER_VIP:
                    retr = {
                        ...retr,
                        bonusSum: retr.list.find(el => el.name === 'Wartość retra [po redukcji]')?.value
                    }
                    break

                case TYPES.SUPPLEMENTARY_CONTRACTOR:
                    component = 'TableContractorBonus'
                    break

                case TYPES.CLIENT_BUDGET:
                    retr = {
                        ...retr,
                        bonusSum: retr.valueSum
                    }
                    break

                case TYPES.CLAIMS_ADJUSTMENTS:
                    retr = {
                        ...retr,
                        ...mapClaimsAdjustments(retr),
                        bonusSum: retr.adjustmentsValueSum + retr.reclamationsValueSum
                    }

                    if (retr.adjustmentsValueSum === null || retr.reclamationsValueSum === null) {
                        retr.bonusSum = null
                    }
                    component = 'TableAdvanced'
                    break
                }

                retr.name = name

                return {
                    name,
                    retr,
                    active: false,
                    component: () => import(`./${component}.vue`)
                }
            })
        }
    },

    methods: {
        isNotEmpty(retr) {
            return typeof retr.bonusSum === 'number' && !isNaN(retr.bonusSum)
        },

        onHeaderClick(el) {
            if (this.isNotEmpty(el.retr)) {
                this.openedRetrs = this.openedRetrs.includes(el.name)
                    ? this.openedRetrs.filter(name => name !== el.name)
                    : [...this.openedRetrs, el.name]
            }
        }
    },

    created() {
        this.TYPES_DICT = TYPES_DICT
    }
}
</script>

<style lang="scss">
@import '../../../styles/_custom.scss';
@import '~bootstrap/scss/mixins';
@import '../../../styles/components/retr-common';

.retr-list {
    .a-accordion__header {
        padding-right: 20px !important
    }
}

.retr {
    --button-space: 87px;

    .clientBudget {
        .retr {
            &__value {
                font-weight: 700;
            }
        }
    }

    &__header {
        white-space: normal;
        text-align: left;
        display: flex;
        gap: 1rem;
        justify-content: space-between;
        align-items: center;
        width: 100%;
    }

    &__header-name {
        display: flex;
        align-items: center;
        gap: 0.5rem;

        .a-icon {
            min-width: 24px;
        }
    }

    @include media-breakpoint-down(sm) {
        .a-accordion__header {
            gap: 8px;
        }
    }

    @include media-breakpoint-down(xs) {
        &__header {
            font-size: 16px;
            line-height: 1.2;
        }
    }
}
</style>